var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconTree = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12.75 18.7192C17.37 18.3382 21 14.4683 21 9.75C21 4.77975 16.9703 0.75 12 0.75C7.02975 0.75 3 4.77975 3 9.75C3 14.4683 6.63 18.3382 11.25 18.7192V22.5C11.25 22.914 11.586 23.25 12 23.25C12.414 23.25 12.75 22.914 12.75 22.5V18.7192ZM12.75 17.2132V12.375L15.45 10.35C15.7815 10.1018 15.8482 9.6315 15.6 9.3C15.3517 8.9685 14.8815 8.90175 14.55 9.15L12.75 10.5V7.5C12.75 7.086 12.414 6.75 12 6.75C11.586 6.75 11.25 7.086 11.25 7.5V13.4393L8.71875 11.4142C8.3955 11.1555 7.923 11.208 7.66425 11.5312C7.4055 11.8545 7.458 12.327 7.78125 12.5858L11.25 15.3608V17.2132C7.46025 16.8368 4.5 13.6395 4.5 9.75C4.5 5.60775 7.85775 2.25 12 2.25C16.1423 2.25 19.5 5.60775 19.5 9.75C19.5 13.6388 16.5398 16.8368 12.75 17.2132Z", fill: "black" }))),
        alt: 'Icon Tree',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconTree;
//# sourceMappingURL=index.js.map